import React, {Component, MouseEvent} from 'react';
import {logIn} from "../helpers/login";
import Helmet from 'react-helmet';
import { withRouter, RouteComponentProps } from 'react-router-dom';

type LogInProps = {}

type LogInState = {}

class LogIn extends Component<LogInProps & RouteComponentProps<any>, LogInState> {

    handleLogIn = (e: MouseEvent<HTMLButtonElement>)=> {
        e.preventDefault();
        let redir: string | undefined;
        if (this.props.location.state) {
            redir = this.props.location.state['redir'];
        }
        logIn(redir);
    };

    render() {
        return <>
            <Helmet>
                <title>Log In</title>
            </Helmet>

            <div className="container has-text-centered inner">
                <div className="login-outer">
                    <div className="login-inner">
                        <button className="button is-large is-primary" onClick={this.handleLogIn}>Log In</button>
                    </div>
                </div>
            </div>
        </>;
    }
}

export default withRouter(LogIn);
